import { useEffect } from 'react';
import { configure } from 'axios-hooks';
import createAxios from '.';

const Api = () => {

    useEffect(() => {
        const axiosInstance = createAxios();
        configure({ axios: axiosInstance });
    }, []);

    return null;
};

export default Api;
